import React from 'react';
import PropTypes from 'prop-types';
import createUniqueId from '../../../shared/helpers/createUniqueId';
import ProductCard from '../../../shared/components/ProductCard/ProductCard';
import normalizer from '../../../product/normalizer';


const ProductResults = function ProductResultsComponent({ productIds, analytics, categoryTitle }) {
  return (
    <React.Fragment>
      { productIds && !!productIds.length && productIds.length > 0 &&
          productIds.map((product) => {
            const normalizedProduct = normalizer(product.details);
            const uniqueId = createUniqueId(product.productID);

            return (
              <div className="results-grid__product-card" key={uniqueId}>
                <ProductCard
                  product={normalizedProduct}
                  analytics={analytics}
                  list={categoryTitle}
                />
              </div>
            );
          })
      }
    </React.Fragment>
  );
};

ProductResults.propTypes = {
  productIds: PropTypes.arrayOf(PropTypes.shape({
    productID: PropTypes.string.isRequired,
    details: PropTypes.shape({
      images: PropTypes.shape({}).isRequired,
      productName: PropTypes.string.isRequired,
      price: PropTypes.shape({}).isRequired,
      rebates: PropTypes.shape({
        min: PropTypes.shape({
          value: PropTypes.number.isRequired,
          formatted: PropTypes.string,
        }),
        max: PropTypes.shape({
          value: PropTypes.number.isRequired,
          formatted: PropTypes.string,
        }),
        label: PropTypes.string,
        tooltip: PropTypes.string,
      }),
      rebatePrice: PropTypes.shape({}),
      productUrl: PropTypes.string.isRequired,
      rating: PropTypes.number.isRequired,
      promotions: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
  })),
  analytics: PropTypes.shape({}).isRequired,
  categoryTitle: PropTypes.string.isRequired,
};

ProductResults.defaultProps = {
  productIds: [],
};

export default ProductResults;
